import {FC, memo} from 'react'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import {KTSVG} from '../../../../../_metronic/helpers'
import {Dropdown, Spinner} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {
  ContactGroupMap,
  ContactStatus,
  GetContactParams,
} from '../../../../../services/cellcast.v2.types'
import {openPopup} from '../../../../Components/PopupSlice/popupSlice'
import {getIsDefaultRegion} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import './ContactListActions.scss'
import useResponsive from '../../../../hooks/useResponsive'

type ContactListActionsProp = {
  params: GetContactParams

  contacts: ContactGroupMap[]
  selectedContactGroupIDs: string[]

  showUnsubscribeButton: boolean
  showSubscribeButton: boolean
  showActionOptions?: boolean
  showExportContactButton?: boolean
  showAddTagButton?: boolean
  showDeleteContactList?: boolean
  showAssignButton?: boolean

  isLoadingExport: boolean

  teamMembers?: any[]
  handleExport: () => void
  handleShowQmDrawer: (isShow: boolean) => void
  handleShowBm: () => void
  handleShowAddContactModal: (isShow: boolean) => void
  handleShowAddSingleContact?: (isShow: boolean) => void
  handleShowReSubscribeContactModal: (isShow: boolean) => void
  handleShowAttachTagModal: (isShow: boolean) => void
  handleSubscribe: () => void
  handleUnsubscribe: () => void
  handleDelete: () => void
  handleAssignTo?: (staffMember: any) => void
  showModalConfirmationDeleteList?: () => void
}

const ContactListActions: FC<ContactListActionsProp> = (props) => {
  const {isMobile} = useResponsive()
  // extract props
  const {
    params,
    selectedContactGroupIDs,
    showSubscribeButton,
    showUnsubscribeButton,
    showActionOptions,
    showExportContactButton,
    showAddTagButton,
    showDeleteContactList,
    showAssignButton,
    isLoadingExport,
    teamMembers,
    handleExport,
    handleShowQmDrawer,
    handleShowBm,
    handleShowAddContactModal,
    handleShowAddSingleContact,
    handleShowReSubscribeContactModal,
    handleShowAttachTagModal,
    handleSubscribe,
    handleUnsubscribe,
    handleDelete,
    handleAssignTo,
    showModalConfirmationDeleteList,
  } = props

  // library hook
  const dispatch = useDispatch()

  const isUnsubscribe = params.status === ContactStatus.unsubscribe
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  return (
    <div className={`card-toolbar-wrapper card-toolbar mt-0 ${isMobile ? 'w-100' : ''}`}>
      {AuthenticateUser('upload-contacts') && AuthenticateUser('edit-contact') && (
        <button
          type='button'
          className={`btn btn-primary ${isMobile ? 'flex-fill' : ''}`}
          onClick={() => handleShowAddContactModal(true)}
        >
          <KTSVG path={`/media/icons/duotune/arrows/arr075.svg`} className='svg-icon-3' />
          {isUnsubscribe ? 'Add unsubscribe' : 'Add contacts'}
        </button>
      )}

      <div className='me-0'>
        <Dropdown>
          {(AuthenticateUser('send-quick-sms') ||
            AuthenticateUser('edit-contact') ||
            AuthenticateUser('tag-untag-contacts') ||
            AuthenticateUser('delete-contact')) && (
            <Dropdown.Toggle className={`btn btn-light-primary my-2 m-sm-0 ms-sm-3 ${isMobile ? 'flex-fill' : ''}`}>
              Action
              <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-6 ms-3' />
            </Dropdown.Toggle>
          )}

          <Dropdown.Menu className='w-250px'>
            {showActionOptions && (
              <>
                {AuthenticateUser('send-quick-sms') && (
                  <label className='text-muted p-3 pb-3 fs-7'>ACTIONS</label>
                )}
                {AuthenticateUser('send-quick-sms') && isDefaultRegion && (
                  <Dropdown.Item
                    onClick={handleShowBm}
                    className='menu-content  p-3 fs-8 text-uppercase'
                  >
                    Send Bulk Message
                  </Dropdown.Item>
                )}
                {AuthenticateUser('send-quick-sms') && (
                  <Dropdown.Item
                    onClick={() => {
                      if (selectedContactGroupIDs?.length <= 0) {
                        dispatch(openPopup('Please select at least one contact'))
                        // alert('Please select at least one contact')
                      } else {
                        handleShowQmDrawer(true)
                      }
                    }}
                    className='menu-content   p-3 fs-8 text-uppercase'
                  >
                    Send quick message
                  </Dropdown.Item>
                )}
              </>
            )}

            {AuthenticateUser('edit-contact') && (
              <label className='text-muted p-3 pb-3 pt-7 fs-7'>CONTACT MANAGEMENT</label>
            )}
            {AuthenticateUser('edit-contact') && !isUnsubscribe && (
              <Dropdown.Item
                onClick={() => {
                  handleShowAddSingleContact && handleShowAddSingleContact(true)
                }}
                className='menu-content   p-3 fs-8 text-uppercase '
              >
                Add single contact
              </Dropdown.Item>
            )}
            {AuthenticateUser('list-sub-accounts') && showAssignButton && (
              <Dropdown drop='start'>
                <Dropdown.Toggle
                  variant='light'
                  id='dropdown-assign-to'
                  className='menu-content p-3 bg-white text-dark w-100 text-start'
                >
                  Assign to <i className='bi bi-chevron-right float-end'></i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {teamMembers && teamMembers.length > 0 ? (
                    teamMembers.map((member: any, i: number) => (
                      <Dropdown.Item
                        key={i}
                        onClick={() => {
                          if (selectedContactGroupIDs?.length <= 0) {
                            dispatch(openPopup('Please select at least one contact'))
                          } else if (handleAssignTo) {
                            handleAssignTo(member)
                          }
                        }}
                      >
                        {member?.name}
                      </Dropdown.Item>
                    ))
                  ) : (
                    <Dropdown.Item disabled>No staff members available</Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            )}
            {AuthenticateUser('edit-contact') &&
              (showUnsubscribeButton ? (
                <Dropdown.Item
                  onClick={handleUnsubscribe}
                  className='menu-content  p-3 fs-8 text-uppercase'
                >
                  Unsubscribe selected contact{selectedContactGroupIDs?.length > 1 ? 's' : ''}
                </Dropdown.Item>
              ) : null)}
            {AuthenticateUser('edit-contact') && showSubscribeButton ? (
              <Dropdown.Item
                onClick={handleSubscribe}
                className='menu-content  p-3 fs-8 text-uppercase'
              >
                Subscribe selected contact{selectedContactGroupIDs?.length > 1 ? 's' : ''}
              </Dropdown.Item>
            ) : null}

            {AuthenticateUser('upload-contacts') &&
            AuthenticateUser('edit-contact') &&
            isUnsubscribe &&
            isDefaultRegion ? (
              <Dropdown.Item
                onClick={() => handleShowReSubscribeContactModal(true)}
                className='menu-content  p-3 fs-8 text-uppercase'
              >
                Resubscribe contacts
              </Dropdown.Item>
            ) : null}

            {AuthenticateUser('tag-untag-contacts') && showAddTagButton && (
              <Dropdown.Item
                className='menu-content  p-3 fs-8 text-uppercase'
                onClick={() => {
                  if (selectedContactGroupIDs?.length <= 0) {
                    dispatch(openPopup('Please select at least one contact'))
                  } else {
                    handleShowAttachTagModal(true)
                  }
                }}
              >
                Add Tag
              </Dropdown.Item>
            )}

            {AuthenticateUser('export-contacts') && showExportContactButton && (
              <Dropdown.Item
                className='menu-content  p-3 fs-8 text-uppercase'
                onClick={handleExport}
                disabled={isLoadingExport}
              >
                {isLoadingExport && <Spinner size='sm' className='p-0' />}
                Export{' '}
                {selectedContactGroupIDs?.length
                  ? `${selectedContactGroupIDs.length} Selected`
                  : 'All'}
              </Dropdown.Item>
            )}

            {AuthenticateUser('delete-contact') && (
              <Dropdown.Item
                className='menu-content   p-3 fs-8 text-uppercase text-danger'
                onClick={() => {
                  handleDelete()
                }}
              >
                Delete{' '}
                {selectedContactGroupIDs?.length
                  ? `${selectedContactGroupIDs.length} Selected`
                  : 'All'}{' '}
                Contact
              </Dropdown.Item>
            )}
            {(AuthenticateUser('tag-untag-contacts') || AuthenticateUser('edit-tag')) &&
              showDeleteContactList && (
                <Dropdown.Item
                  className='menu-content   p-3 fs-8 text-uppercase text-danger'
                  onClick={() => {
                    showModalConfirmationDeleteList && showModalConfirmationDeleteList()
                  }}
                >
                  Delete{' '}
                  {selectedContactGroupIDs?.length
                    ? `${selectedContactGroupIDs.length} Selected`
                    : 'All'}{' '}
                  Contact from list
                </Dropdown.Item>
              )}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  )
}

ContactListActions.defaultProps = {
  showActionOptions: true,
  showAssignButton: true,
  teamMembers: [],
}

export default memo(ContactListActions)
